export default "__VITE_ASSET___s1vLLLN__"